import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppFab from "./WhatsAppFab";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col" data-testid="app-shell">
      <Navbar />
      <main className="flex-1 pt-[72px]">{children}</main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
